import type { Company } from "types/Company.type";

import { api } from "utils/api";

export const getCompany = () => api.get<Company>("/company/current");
export const updateCompany = (data: Company) => api.put<Company>("/company/current", data);
